import { put, takeEvery } from 'redux-saga/effects';
import { ENDPOINT } from '../../services/apiUrls';
import { ResponseGenerator } from './common';
import createApiInstance from '../../services/api';
import { BASE_API_URL } from '../../config';
import {
  logoutUser,
  triggerOTP,
  updateLoadingState,
  validateOTP,
} from '../slices';

// Dynamically create the API instance with the base URL
const api = createApiInstance(BASE_API_URL); // Replace BASE_API_URL with the dynamic value you have

function* generateOTP(actions: any) {
  yield put(updateLoadingState({ loaderState: true }));

  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.AUTH.triggerOTP + '/' + actions.payload.phone,
    });

    actions.payload.callback && actions.payload.callback(response);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  } finally {
    yield put(updateLoadingState({ loaderState: false }));
  }
}

function* verifyOTP(actions: any) {
  // yield put(updateLoadingState({ loaderState: true }));

  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url:
        ENDPOINT.AUTH.validateOTP +
        '/' +
        actions.payload.phone +
        '?otp=' +
        actions.payload.otp,
    });

    actions.payload.callback && actions.payload.callback(response);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  } finally {
    // yield put(updateLoadingState({ loaderState: false }));
  }
}

function* loggingOutUser(actions: any) {
  yield put(updateLoadingState({ loaderState: true }));

  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.AUTH.logoutUser + '/' + actions.payload.phone,
    });

    actions.payload.callback && actions.payload.callback(response);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  } finally {
    yield put(updateLoadingState({ loaderState: false }));
  }
}

export default function* root() {
  yield takeEvery(triggerOTP.type, generateOTP);
  yield takeEvery(validateOTP.type, verifyOTP);
  yield takeEvery(logoutUser.type, loggingOutUser);
}
